// Module
var code = "<div class=\"{{ vm.className }}\"> <label>{{ vm.label }}:</label> <div>{{ vm.value }}</div> <a ng-click=\"vm.onClickAnchor()\">{{ vm.anchorText }}</a> </div> ";
// Exports
module.exports = code;